<app-navbar></app-navbar>
<div class="verify-status">
  <div class="ds-card">
    <app-ds-rounded-icon [variant]="content?.iconColor" [icon]="content?.icon" size="large"></app-ds-rounded-icon>
    <h3 class="ds-title-3">{{ content?.title | translate }}</h3>
    <p class="ds-ui-1">{{ content?.subtitle | translate: { expirationHours: 24 } }}</p>
    <app-ds-button width="full" variant="primary" (clicked)="onNavigate(status)">{{ content?.buttonText | translate }}</app-ds-button>
  </div>
</div>
